import { FoodType, MealType } from "model/food/types"
import { IFoodImage } from "model/food/types/base.types"

export const getImagePayload = (food: FoodType | MealType) => {
  if (food.imageId) {
    return { imageId: food.imageId }
  } else if (food.imageUrl) {
    const payload: IFoodImage = { imageUrl: food.imageUrl }
    if (food.previewImageUrl) {
      payload.previewImageUrl = food.previewImageUrl
    }

    return payload
  }
  return {}
}
